// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import theme from '@theme';

const { colors } = theme;

export const StyledLinksNavigation = styled.div`
  align-items: center;
  color: ${colors.gray};
  flex: 1;
  display: none;
  justify-content: center;

  ${breakpoint('desktop')`
    display: flex;
    justify-content: flex-end;
    & > * {
      max-width: calc(130px + 7%);
    }
  `}
  ${breakpoint('mobile', 'desktop')`
  @media only screen and (max-width: 340px) {
  font-size: 15px;
  line-height: 30px;
   
  }
  `}

  @media only screen and (min-width: 1250px) {
    & > * {
      max-width: none;
    }
  }
`;
